<template>
  <div class="contents">
    <div class="zyk-search-wrapper-box">
      <div class="zyk-search-wrapper">
        <div class="zyk-search-con">
          <h2>征集计划查询</h2>
        </div>
      </div>
    </div>
    <div class="list">
      <el-form :model="query" inline>
        <el-form-item label="院校名称" clearable>
          <el-input style="width: 150px;" v-model="query.collegeName" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="专业名称" clearable>
          <el-input style="width: 150px;" v-model="query.specialty_title" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="首选科目" clearable>
          <el-select v-model="query.group_d" style="width: 150px;" placeholder="请选择" size="small">
              <el-option
                v-for="item in group_dArr"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="层次" clearable>
          <el-select v-model="query.batch" style="width: 150px;" placeholder="请选择" size="small">
              <el-option
                v-for="item in batchArr"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="年份" clearable>
          <el-input style="width: 100px;" v-model="query.year" placeholder="请输入年份" size="small"></el-input>
        </el-form-item>
        <el-form-item label-width="80px">
          <el-button type="success" size="small" icon="el-icon-search" @click="handleSearch"
            style="margin: 0px 2px;">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}" v-loading="loading">
        <el-table-column prop="collegeName" label="院校名称" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="collegeNameRemark" label="备注" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="specialty_title" label="专业名称" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="major_field" label="专业方向" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="group_d" label="首选科目" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="the_second" label="次选科目" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="one_zhengji" label-width="100" label="一次征集" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="two_zhengji" label-width="100" label="二次征集" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="year" label-width="100" label="年份" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="bacth" label-width="100" label="层次" show-overflow-tooltip align="center">
        </el-table-column>
      </el-table>
      
      <div style="width: 100%;margin-top: 20px;margin-bottom:20px;display: flex;align-items: center;justify-content: center;">
        <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="query.page"
              :page-sizes="[20,50,100,120]"
              :page-size="query.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
      </div>
    </div>>
  </div>
</template>

<script>
  import {
    mapGetters
  } from "vuex"
  import cityJson from "@/utils/city.json"
  import {
    Collectionplan_index
  } from "@/api/gw/major.js"
  export default{
    computed: {
      ...mapGetters(['isLogin', "userinfo"]),
    },
    data(){
      return{
          loading: false,
          list: [],
          total: 0,
          query: {
            page: 1,
            limit: 20,
            collegeName:"",//院校名称
            specialty_title:"",//专业名称
            group_d:"",//首选科目
            year:"",//年份
            batch:"",//层次
          },
          group_dArr:[
            {id:"",title:"全部"},
            {id:"物理科目组合",title:"物理科目组合"},
            {id:"历史科目组合",title:"历史科目组合"},
          ],
          batchArr:[
            {id:"",title:"全部"},
            {id:"本科批",title:"本科批"},
            {id:"专科批",title:"专科批"},
          ],
      }
    },
    mounted() {
      this.getList();
      if (localStorage.getItem("qichengUserToken")) {
        this.$store.dispatch("getUserInfo");
      }
    },
    methods: {
      getList() {
        this.loading = true
        const examTypeRaw = localStorage.getItem('selectedExamType');
        const examType = ['1','2','3'].includes(String(examTypeRaw)) ? String(examTypeRaw) : '1';
        const params = { ...this.query, examType };
        Collectionplan_index(params).then(res => {
          this.total = res.data.total
          this.list = res.data.data
        }).finally(() => {
          this.loading = false
        })
      },
      handleSearch() {
        this.query.page = 1
        this.getList();
      },
      handleSizeChange(val) {
        this.limit = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .list {
    width: 1250px;
    margin: 0 auto;
    padding-top: 30px;
  }

  .zyk-search-wrapper-box {
    background: linear-gradient(180deg, #49c48d, #1cb278);

    .zyk-search-wrapper {
      height: 200px;
      background: url(../../assets/banner-zyk-pc.png) no-repeat top;
      text-align: center;

      .zyk-search-con {
        width: 520px;
        padding-top: 36px;
        margin: 0 auto;

        h2 {
          height: 53px;
          font-size: 38px;
          font-weight: 600;
          color: #fff;
          line-height: 53px;
          text-shadow: 0 2px 2px rgba(0, 0, 0, .06);
          margin-bottom: 20px;
          letter-spacing: 2px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Collectionplan/index.vue